/*
 *  Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('NodeMember', ['$resource', 'NodeMemberInterceptor',
        function ($resource, NodeMemberInterceptor) {
            return $resource('/sync_and_share_nodes/:node_uuid/members/:id', {node_uuid: '@node_uuid', id: '@id'}, {
                query: {
                    method: 'GET',
                    params: {
                        per_page: 2048,
                        include_groups: true
                    },
                    isArray: true,
                    interceptor: NodeMemberInterceptor
                },
                create: {
                    method: 'POST',
                    transformRequest: function (data) {
                        return angular.toJson(data);
                    }
                },
                update: {
                    method: 'PUT',
                    params: {
                        id: '@id'
                    },
                    interceptor: NodeMemberInterceptor,
                    transformRequest: function (data) {
                        var attrsWhitelist = ['read_only', 'can_invite', 'can_view_members'],
                            filteredData = {};

                        for (var i in attrsWhitelist) {
                            filteredData[attrsWhitelist[i]] = data[attrsWhitelist[i]];
                        }

                        return angular.toJson(filteredData);
                    }
                },
                removeAll: {
                    method: 'DELETE'
                }
            });
        }]);
